<div class="full-height">
  <div style="display: flex; height: 100%; flex-direction: row">
    <div style="flex-grow: 1; overflow-y: auto; display: flex">
      <div style="width: 100%; height: 100%">
        <interactive-schedule
          style="{'width': '100%'}"
          (dateChangeEvent)="dateChange($event)"
          [inputJobs]="inputJobs"
          [supplierIds]="supplierIds"
          [isVME]="true"
        ></interactive-schedule>
      </div>
    </div>
    <div
      style="
        height: 100%;
        flex: 0 0 250px;
        overflow-y: auto;
        padding-left: 4px;
        display: flex;
        flex-direction: column;
      "
    >
      <div style="flex-shrink: 1">
        <div class="pt-3 pb-3 text-center">
          <h2 class="p-0 m-0">Suppliers</h2>
        </div>
      </div>

      <div style="flex-grow: 1; overflow-y: auto">
        <div class="facets-flex-wrapper" *ngIf="filterGroups.length > 0; else loadingFilters">
          <div id="facets-list-container" class="facets-container">
            <div class="facets-inner-container">
              <div
                id="facetslist"
                class="facets-list"
                *ngFor="let filter of filterGroups; let i = index"
              >
                <p-panel
                  id="engineius-panel-{{ i }}"
                  [pTooltip]="filterDefinitions[i].tooltip"
                  tooltipPosition="top"
                >
                  <p-header>
                    <div class="facet-title-bar">
                      <div
                        class="facet-title-text"
                        [id]="'facet-' + i"
                        (click)="isFacetOpen[i] = !isFacetOpen[i]"
                      >
                        <span *ngIf="!isFacetOpen[i]"><i class="fa fa-caret-down"></i></span>
                        <span *ngIf="isFacetOpen[i]"><i class="fa fa-caret-up"></i></span>
                        {{ filter.name }}
                        <span
                          *ngIf="selectedFilters[i] && selectedFilters[i].length > 0"
                          [escape]="false"
                          [tooltipStyleClass]="'xtooltip'"
                          [pTooltip]="getSelectedFiltersString(i)"
                          class="p-badge filters"
                          style="text-align: center; cursor: pointer"
                          >{{ selectedFilters[i].length }}</span
                        >
                      </div>

                      <div style="flex-grow: 1">
                        <input
                          *ngIf="filterDefinitions[i].searchable"
                          [(ngModel)]="filterDefinitions[i].searchKeyword"
                          autocomplete="off"
                          name="filter"
                          class="filter-input"
                          (input)="applyFilter(i, $event.target.value, 'label', 'contains')"
                        />
                      </div>

                      <div
                        style="flex-shrink: 1"
                        *ngIf="filterDefinitions[i].searchable"
                        pTooltip="Filter the list by name"
                        class="filter-search-icon"
                      >
                        <i class="fa fa-search"></i>
                      </div>

                      <div style="flex-shrink: 1; white-space: nowrap" *ngIf="isFacetOpen[i]">
                        <div
                          pTooltip="Switch between alphabetic and 'highest count' ordering"
                          class="filter-sort-icon"
                          (click)="sortFilter(i)"
                        >
                          <i class="fa fa-sort"></i>
                        </div>
                      </div>
                    </div>
                  </p-header>

                  <p-table
                    selectionMode="multiple"
                    [(selection)]="selectedFilters[i]"
                    [value]="filter.selectItems"
                    [lazy]="false"
                    (onRowSelect)="filterRowSelectionChanged(i)"
                    (onRowUnselect)="filterRowSelectionChanged(i)"
                    id="facetTable"
                    #facetTable
                    [paginator]="false"
                    rowHover="true"
                    resizableColumns="true"
                    [metaKeySelection]="false"
                    [style]="{
                      'max-height': '200px',
                      'overflow-y': 'scroll',
                      display: isFacetOpen[i] ? 'block' : 'none'
                    }"
                    (onFilter)="handleFilter($event, facetTable.totalRecords)"
                  >
                    <ng-template pTemplate="body" let-data>
                      <tr [pSelectableRow]="data">
                        <td>
                          <span
                            [ngClass]="{ 'red-label': data.dataOutOfRange }"
                            appendTo="body"
                            pTooltip="{{ data.label }}"
                            tooltipPosition="top"
                            >{{ data.label }}</span
                          >
                        </td>
                        <td style="width: 40px; text-align: right">
                          <span class="p-badge">{{ data.count }}</span>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>

                  <!--- DATATABLE DEPRECATED --
                  <p-dataTabl selectionMode="multiple" [(selection)]="selectedFilters[i]"
                               [value]="filter.selectItems" [lazy]="false"
                               (onRowSelect)="filterRowSelectionChanged(i)"
                               (onRowUnselect)="filterRowSelectionChanged(i)"
                               id="facetTable" #facetTable [immutable]="false"
                               [paginator]="false" rowHover="true" resizableColumns="true"
                               [metaKeySelection]="false"
                               [style]="{
                                    'max-height': '200px',
                                    'overflow-y': 'scroll',
                                    'display': (isFacetOpen[i]) ? 'block' : 'none'
                                 }"
                               (onFilter)="handleFilter($event,facetTable.totalRecords)"
                  >

                    <p-column [editable]="false" field="label">
                      <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                  <span [ngClass]="{'red-label': data.dataOutOfRange}" appendTo="body" pTooltip="{{data.label}}"
                        tooltipPosition="top">{{data.label}}</span>
                      </ng-template>
                    </p-column>
                    <p-column [editable]="false">
                      <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                        <span class="p-badge">{{data.count}}</span>
                      </ng-template>
                    </p-column>

                  </p-dataTable>

                  -->
                </p-panel>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="selectedSuppliers" class="facets-list" style="overflow-x: hidden">
        <p-panel>
          <p-header>
            <div class="facet-title-bar">
              <div class="facet-title-text" [id]="'facet-suppliers-chosen'">Selected Suppliers</div>
            </div>
          </p-header>

          <p-table
            selectionMode="multiple"
            [(selection)]="selectedSuppliers"
            [value]="selectedSuppliers"
            [lazy]="false"
            (onRowUnselect)="changeSelectedSuppliers($event)"
            #facetTable
            [emptyMessage]="'No suppliers selected'"
            [paginator]="false"
            rowHover="true"
            resizableColumns="true"
            [metaKeySelection]="false"
            [style]="{
              'max-height': '200px',
              'overflow-y': 'scroll'
            }"
          >
            <ng-template pTemplate="body" let-data>
              <tr [pSelectableRow]="data">
                <td>
                  <span appendTo="body" pTooltip="{{ data.supplierName }}" tooltipPosition="top">{{
                    data.supplierName
                  }}</span>
                </td>
                <td style="width: 40px; text-align: right">
                  <span class="p-badge jobsInWindow-{{ data.jobsInWindow }}">{{
                    data.jobsInWindow
                  }}</span>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!---
          <p-dataTabl selectionMode="multiple" [(selection)]="selectedSuppliers"
                       [value]="selectedSuppliers" [lazy]="false"
                       (onRowUnselect)="changeSelectedSuppliers($event)"
                       #facetTable [immutable]="false"
                       [emptyMessage]="'No suppliers selected'"
                       [paginator]="false" rowHover="true" resizableColumns="true"
                       [metaKeySelection]="false"
                       [style]="{
                                    'max-height': '200px',
                                    'overflow-y': 'scroll'
                                 }"
          >

            <p-column [editable]="false" field="label">
              <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                        <span appendTo="body" pTooltip="{{data.supplierName}}"
                              tooltipPosition="top">{{data.supplierName}}</span>
              </ng-template>
            </p-column>
            <p-column [editable]="false">
              <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                <span class="p-badge jobsInWindow-{{ data.jobsInWindow }}">{{data.jobsInWindow}}</span>
              </ng-template>
            </p-column>
          </p-dataTable>

          --->
        </p-panel>
      </div>

      <div id="facetsuppliers" class="facets-list" style="flex-shrink: 1; overflow-x: hidden">
        <p-panel>
          <p-header>
            <div class="facet-title-bar">
              <div class="facet-title-text" [id]="'facet-supplier'">
                Suppliers
                <span
                  *ngIf="supplierIds.length > 0"
                  class="p-badge filters"
                  style="text-align: center; cursor: pointer"
                  >{{ supplierIds.length }}</span
                >
              </div>

              <div style="flex-grow: 1">
                <input
                  [(ngModel)]="supplierSearchKeyword"
                  autocomplete="off"
                  name="filter"
                  class="filter-input"
                  (input)="applySupplierFilter($event.target.value)"
                />
              </div>

              <div
                style="flex-shrink: 1"
                pTooltip="Filter the list by name"
                class="filter-search-icon"
              >
                <i class="fa fa-search"></i>
              </div>
            </div>
          </p-header>

          <p-table
            selectionMode="multiple"
            [(selection)]="selectedSuppliers"
            [value]="workingSetWithoutSelected()"
            [lazy]="false"
            (onRowSelect)="changeSelectedSuppliers($event)"
            (onRowUnselect)="changeSelectedSuppliers($event)"
            #facetTable2
            [paginator]="false"
            rowHover="true"
            resizableColumns="true"
            [metaKeySelection]="false"
            [style]="{
              'max-height': '200px',
              'overflow-y': 'scroll'
            }"
            (onFilter)="handleFilter($event, facetTable.totalRecords)"
          >
            <ng-template pTemplate="body" let-data>
              <tr [pSelectableRow]="data">
                <td>
                  <span appendTo="body" pTooltip="{{ data.supplierName }}" tooltipPosition="top">{{
                    data.supplierName
                  }}</span>
                </td>
                <td style="width: 40px; text-align: right">
                  <span class="p-badge jobsInWindow-{{ data.jobsInWindow }}">{{
                    data.jobsInWindow
                  }}</span>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <!---
          <p-dataTabl selectionMode="multiple" [(selection)]="selectedSuppliers"
                       [value]="workingSetWithoutSelected()" [lazy]="false"
                       (onRowSelect)="changeSelectedSuppliers($event)"
                       (onRowUnselect)="changeSelectedSuppliers($event)"
                       #facetTable2 [immutable]="false"
                       [paginator]="false" rowHover="true" resizableColumns="true"
                       [metaKeySelection]="false"
                       [style]="{
                                    'max-height': '200px',
                                    'overflow-y': 'scroll'
                                 }"
                       (onFilter)="handleFilter($event,facetTable.totalRecords)"
          >

            <p-column [editable]="false" field="label">
              <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                        <span appendTo="body" pTooltip="{{data.supplierName}}"
                              tooltipPosition="top">{{data.supplierName}}</span>
              </ng-template>
            </p-column>
            <p-column [editable]="false">
              <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                <span class="p-badge jobsInWindow-{{ data.jobsInWindow }}">{{data.jobsInWindow}}</span>
              </ng-template>
            </p-column>
          </p-dataTable>
          -->
        </p-panel>
      </div>

      <div style="flex: 0 0 55px; width: 100%; padding-top: 10px; text-align: center">
        <div style="padding-top: 5px">
          <button
            pButton
            [label]="settingFilters ? 'Wait..' : 'Clear'"
            (click)="clearAllFilters()"
            style="width: 80%"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #loadingFilters>
  <div style="height: 100%">
    <div style="display: flex; align-items: center; height: 100%; text-align: center">
      <div style="width: 100%">
        <div><i class="fa fa-spin fa-spinner fa-2x"></i></div>
        <div class="pt-2"><strong>Filters Loading</strong></div>
      </div>
    </div>
  </div>
</ng-template>
